module.exports = __webpack_public_path__ + "img/cprs_preview.28041261.jpg";